import React, { Component } from 'react';
import { SpinLoader } from 'app/components';
import { SearchFilters } from 'app/area/search-filters/search-filters';
import { NumberOfResults } from 'app/area/codetable/list/search';
import { CodeCategory } from 'app/area/codetable/list/search/code-category';
import { CodetableListItems } from 'app/area/codetable/list/list-items';
import { addLinkFactory } from 'app/area/codetable/list/list-renderer/common/add-link-factory';
import { CodetableListComponentProps } from './types';

import styles from './default-codetable-list-component.scss';

export class DefaultCodetableListComponent extends Component<CodetableListComponentProps> {
  public render() {
    const { category, metadata, codetableOptions, isHierarchy, isHierarchyMode, shouldRenderList,
      shouldRenderSpinLoader, updateCategory, loadCodetableOptions, hasCategoryMetadata, hasSelectedCategory,
      breadcrumbs, codetableId, codeId, codeListBranch, rootBranch, codeAccessConfiguration,
      codeListBranchState, loadFromParent, expandCodeItem, deleteCodeItem,
      listCategoryLabel, loadCodesAccess, clearCodesAccess,
      itemAccess, fetchingItemAccess, translation } = this.props;

    return <SearchFilters {...this.props}>
      <div className={`${styles.codetableListContainer} ${styles.codetableListCenter}`}>
        <div className={styles.codetableListHolder}>
          <CodeCategory
            breadcrumbs={breadcrumbs}
            category={category}
            metadata={metadata}
            options={codetableOptions}
            loadOptions={loadCodetableOptions}
            onChange={updateCategory}
            translation={translation}
            listCategoryLabel={listCategoryLabel}
          />
          <div className={styles.numberOfResults}>
            {(!hasCategoryMetadata || (hasCategoryMetadata && hasSelectedCategory))
              && <NumberOfResults
                rootBranch={rootBranch}
                translation={this.props.translation} />}
          </div>

          {shouldRenderSpinLoader ? <SpinLoader /> : undefined}
          {
            shouldRenderList && <div className={`${styles.listItemsContainer} ${isHierarchyMode ? styles.hierarchyResults : ''}`}>

              <div className={styles.listItems}>
                <CodetableListItems
                  itemAccess={itemAccess}
                  fetchingItemAccess={fetchingItemAccess}
                  breadcrumbs={breadcrumbs}
                  treeDepthLevel={0}
                  hierarchyMetadata={[]}
                  isMetadataSequence={metadata?.features?.sequence}
                  isZebra={undefined}
                  codetableId={codetableId}
                  codetableName={metadata?.label}
                  codeId={codeId}
                  isHierarchyMode={isHierarchyMode}
                  isHierarchy={isHierarchy}
                  codeAccessConfiguration={codeAccessConfiguration}
                  codeListBranchState={codeListBranchState}
                  codeListBranch={codeListBranch}
                  loadFromParent={loadFromParent}
                  expandCodeItem={expandCodeItem}
                  deleteCodeItem={deleteCodeItem}
                  loadCodesAccess={loadCodesAccess}
                  clearCodesAccess={clearCodesAccess}
                  parentId={undefined}
                  translation={translation}
                  addLinkFactory={addLinkFactory} />
              </div>
            </div>
          }
          {hasCategoryMetadata && !hasSelectedCategory && <p className="no-content">{translation.no_category}</p>}
        </div>
      </div>
    </SearchFilters>;
  }
}
